import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useLanguage, scrollToId } from "../context/LanguageContext";

const Navbar = () => {
  const { lang, setLang, t } = useLanguage();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,box-shadow,border-color] duration-500 border-b ${
        scrolled
          ? "bg-travertine-light/85 backdrop-blur-md border-ink/10"
          : "bg-transparent border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 h-[72px] flex items-center justify-between">
        <button
          data-testid="navbar-brand"
          onClick={() => window.__lenis?.scrollTo(0, { duration: 1.4 })}
          className="font-serif text-xl sm:text-2xl tracking-tight text-ink"
        >
          Emanuela <span className="italic text-gold">Serena</span>
        </button>

        <nav data-testid="navbar-nav-links" className="hidden lg:flex items-center gap-8">
          {t.nav.map((item) => (
            <button
              key={item.id}
              data-testid={`nav-link-${item.id}`}
              onClick={() => scrollToId(item.id)}
              className="text-xs font-mono uppercase tracking-[0.2em] text-ink/60 hover:text-gold transition-colors duration-300"
            >
              {item.label}
            </button>
          ))}
        </nav>

        <div
          data-testid="navbar-lang-switcher"
          className="flex items-center gap-1 font-mono text-xs tracking-[0.2em] border border-ink/15 rounded-full px-3 py-1.5 bg-travertine-light/60 backdrop-blur-sm"
        >
          {["it", "en"].map((l, i) => (
            <span key={l} className="flex items-center gap-1">
              {i === 1 && <span className="text-ink/25 mx-1">|</span>}
              <button
                data-testid={`lang-switch-${l}`}
                onClick={() => setLang(l)}
                className={`uppercase transition-colors duration-300 ${
                  lang === l ? "text-gold border-b border-gold" : "text-ink/50 hover:text-ink"
                }`}
              >
                {l}
              </button>
            </span>
          ))}
        </div>
      </div>
    </motion.header>
  );
};

export default Navbar;
